<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
  import { onMounted, provide } from 'vue'
  import { useRouter } from 'vue-router'
  import { AUTHZ_INTERCEPTOR_KEY } from './components/features/Authentication/services/authorization-interceptor'
  import { injectTyped } from './inject'
  import { STATUS_CODE_INTERCEPTOR_KEY } from './components/features/Authentication/services/status-code-interceptor'
  import { LOADING_INTERCEPTOR_KEY } from './components/features/Authentication/services/loading-interceptor'

  // Provide router and appConfig for @itemis-solutions/platform-web-components
  provide('router', useRouter())
  provide('appConfig', {
    appUrl: window.location.origin,
    invitationUrl: `${window.location.origin}/accept-invitation/{invitationid}`,
  })

  onMounted(() => {
    injectTyped(AUTHZ_INTERCEPTOR_KEY).enable()
    injectTyped(STATUS_CODE_INTERCEPTOR_KEY).enable()
    injectTyped(LOADING_INTERCEPTOR_KEY).enable()
  })
</script>
